module.exports = __webpack_public_path__ + "static/media/ticon3.8e8efd3f.webp";